import React from "react"
import {
  Form,
  Input,
  Button,
  Row,
  Col,
} from "antd"
import PropTypes from "prop-types"
import { autobind } from "core-decorators"
import { mapPropsToFields } from "utils/form"
import createLanguage from "hoc/create-lang"

const FormItem = Form.Item

@Form.create({
  mapPropsToFields: ({ initialValues }) => {
    if (!initialValues) return
    return mapPropsToFields({ initialValues })
  }
})
@createLanguage
@autobind
export default class HookForm extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func
  }

  // constructor(props) {
  //   super(props)
  //   // const translate = this.props.lang.t
  //   // this.i18n = {
  //   //   enableTimeline: translate("organization.form.timeline.label.enabled"),
  //   //   enableShareAPI: translate("organization.form.enableShareAPI"),
  //   //   apiKey: translate("organization.form.apiKey"),
  //   //   generateApiKey: translate("organization.form.generateApiKey"),
  //   //   regenerateApiKey: translate("organization.form.regenerateApiKey"),
  //   //   timelineKey: translate("organization.form.timeline.input.label.key"),
  //   //   timelineSecret: translate(
  //   //     "organization.form.timeline.input.label.secret"
  //   //   ),
  //   //   timelineAppId: translate("organization.form.timeline.input.label.appId")
  //   // }

  // }

  handleSubmit(e) {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (err) return
      const data = values

      // Callback submit form Container Component
      this.props.onSubmit(data)
    })
  }

  render() {
    // console.log("this.props.initialValues", this.props.initialValues)
    const { form: { getFieldDecorator } } = this.props
    // const { timeline, databaseInfo } = this.props.initialValues


    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={24}>
          <Col span={12}>
            <FormItem label='Create hook'>
              {getFieldDecorator(`create`, {
                initialValue: this.props.initialValues
                  ? this.props.initialValues.orgHook.create
                  : null,
                rules: [
                  {
                    required: true,
                    message: 'required'
                  }
                ]
              })(
                <Input placeholder='https://hooks.io/abc' />
              )}
            </FormItem>
            <FormItem label='Update hook'>
              {getFieldDecorator(`update`, {
                initialValue: this.props.initialValues
                  ? this.props.initialValues.orgHook.update
                  : null,
                rules: [
                  {
                    required: true,
                    message: 'required'
                  }
                ]
              })(
                <Input
                  placeholder='https://hooks.io/xyz'
                />
              )}
            </FormItem>
            <FormItem label='Delete hook'>
              {getFieldDecorator(`delete`, {
                initialValue: this.props.initialValues
                  ? this.props.initialValues.orgHook.delete
                  : null,
                rules: [
                  {
                    required: true,
                    message: 'required'
                  }
                ]
              })(
                <Input
                  placeholder='https://hooks.io/def'
                />
              )}
            </FormItem>
          </Col>
        </Row>


        <FormItem>
          <Button style={{ width: "100%" }} type="primary" htmlType="submit">
            Save
          </Button>
        </FormItem>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/hook/form.js